import { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem("pp_token"));
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (!token) { setChecking(false); return; }
    api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("pp_token"); setToken(null); })
      .finally(() => setChecking(false));
  }, [token]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pp_token", data.token);
    setToken(data.token);
    setUser(data.user);
  };
  const logout = () => { localStorage.removeItem("pp_token"); setToken(null); setUser(null); };

  return (
    <AuthContext.Provider value={{ token, user, checking, login, logout, authHeaders: { Authorization: `Bearer ${token}` } }}>
      {children}
    </AuthContext.Provider>
  );
}
